import type { NumberFormat } from '@intlify/core-base'
import type { I18nOptions } from 'vue-i18n'

const defaultFormat = {
  decimal: {
    style: 'decimal',
    maximumFractionDigits: 2,
    useGrouping: true,
  },
  percent: {
    style: 'percent',
    maximumFractionDigits: 2,
    useGrouping: true,
  },
  currency: {
    style: 'currency',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    currencyDisplay: 'narrowSymbol',
    useGrouping: true,
  },
} satisfies NumberFormat

const numberFormats = {
  en: defaultFormat,
  es: defaultFormat,
} satisfies I18nOptions['numberFormats']

export default numberFormats
